export default __webpack_public_path__ + "static/progaming-logo-37d78ecfa8dadfd8dde67b57331915c3.png";